export const SCHEMA_NAME = "WarrantClearanceInfo";

export const FIELDS = {
  BODY_RECEIVED: "bodyReceived",
  CLEARANCE_COMMENTS: "clearanceComments",
  CLEARANCE_DATE: "clearanceDate",
  CLEARANCE_REASON_ID: "clearanceReasonID",
  CLEARANCE_TIME: "clearanceTime",
  CLEARED_BY_STAFF_ID: "clearedByStaffID",
  MONEY_RECEIVED: "moneyReceived",
  RECEIVED_DATE: "receivedDate",
  WARRANT_CLEARANCE_INFO_ID: "warrantClearanceInfoID",
  WARRANT_ID: "warrantID",
};
